define('view/controller/booking/datetime/TimeDefaultView',['require','lib/view/CompositeView','backbone','lib/view/BookingUrlBuilder'],function (require) {

    var CompositeView = require('lib/view/CompositeView');
    var Backbone = require('backbone');
    var BookingUrlBuilder = require('lib/view/BookingUrlBuilder');

    /**
     * Default time view
     *
     * @class TimeDefaultView
     */
    return CompositeView.extend({
        
        ui: {
            'navigateToDate': '.sb-date-navigate',
            'nextAvailableDate': '.sb-next-available-date'
        },
        events: {
            'click @ui.navigateToDate': '_navigateToDate',
            'click @ui.nextAvailableDate': '_navigateToNextAvailableDate'
        },

        childViewOptions: function (model, index) {
            return {
                clientTimeZone: this.getOption('clientTimeZone')
            };
        },

        _daysDiff: 1,
        _errorMessage: null,

        initialize: function () {
            if (this.getOption('clientTimeZone')) {
                this.listenTo(this.getOption('clientTimeZone'), 'sync', this.destroyChildren);
            }
            if (this.getOption('timeValidateModel')) {
                this.listenTo(this.getOption('timeValidateModel'), 'sync', this.renderView);
            }
            this.listenTo(this.getOption('bookingModel'), 'change:service', this.updateBookingInfo);
            this.listenTo(this.getOption('bookingModel'), 'change:provider', this.updateBookingInfo);
            
            this.listenTo(this.collection, 'refetch', function () {
                if (!this.isDestroyed) this.render();
            });

            this.waitingListHelperModel = this.getOption('waitingListHelperModel');

            if(this.waitingListHelperModel) {
                this.listenTo(this.waitingListHelperModel, 'change', this.renderView);
            }
        },

        updateBookingInfo: function () {
            var model = this.getOption('bookingModel');
            if (model.get('service') && model.get('provider')) {
                this.renderView();
            }
        },

        renderView: function () {
            if (!this.isDestroyed) {
                this.render();
            }
        },

        filter: function () {
            return this.getOption('clientTimeZone').isReady();
        },

        serializeData: function () {
            var result = CompositeView.prototype.serializeData.apply(this);

            var currentDate = new Date();
            if (this.getOption('bookingModel').get('start_date')) {
                currentDate = Date.parseMysqlDate(
                    this.getOption('bookingModel').get('start_date')
                );
            }

            var day = 24*60*60*1000;
            var nextDate = new Date(currentDate.getTime() + day * this._daysDiff);
            var prevDate = new Date(currentDate.getTime() - day * this._daysDiff);
            var nextMonth = new Date(currentDate.getTime());
            var prevMonth = new Date(currentDate.getTime());
            nextMonth.setDate(1);
            nextMonth.setMonth(nextMonth.getMonth()+1);
            prevMonth.setDate(1);
            prevMonth.setMonth(prevMonth.getMonth()-1);

            result.next_date = nextDate.getMysqlDate();
            result.prev_date = prevDate.getMysqlDate();
            result.next_month = nextMonth.getMysqlDate();
            result.prev_month = prevMonth.getMysqlDate();
            result.current_date = currentDate;
            result.timeframe = Config.getInstance().getTimeFrame();
            result.current_month = currentDate.getMonth();
            result.current_year = currentDate.getFullYear();
            result.week_days = currentDate.getWeekDaysList('medium');
            result.show_navigation = this.getOption('showNavigation');

            result.selected_service = this.getOption('bookingModel').get('service_id');

            //console.log(this.getOption('bookingModel'));

            if(this.waitingListHelperModel) {
                result.is_available_date = this.waitingListHelperModel.isTodayOrFutureDates() && this.waitingListHelperModel.isWorkDateInterval();
            }

            if (this.getOption('clientTimeZone')) {
                result.time_diff = this.getOption('clientTimeZone').get('time_diff');
            }

            if (this.getOption('timeValidateModel').get('error')) {
                this._errorMessage = this.getOption('timeValidateModel').get('error');
            }
            if (this._errorMessage) {
                result.error_message = this._errorMessage;
            }
            result.is_empty = this.isTimeCollectionEmpty();
            result.is_loaded = this.isTimeCollectionLoaded();

            return result;
        },

        isTimeCollectionEmpty: function () {
            if (!this.getOption('clientTimeZone').isReady()) {
                return true;
            }

            return !this.getTimeCollection() || !this.getTimeCollection().length;
        },

        isTimeCollectionLoaded: function () {
            if (!this.getTimeCollection()) {
                return false;
            }
            if (_.isFunction(this.getTimeCollection().hasSynchronized) && !this.getTimeCollection().hasSynchronized()) {
                return false;
            }
            return this.getOption('clientTimeZone').isReady();
        },

        getTimeCollection: function () {
            return this.collection;
        },

        onRender: function () {
            if (this._errorMessage) {
                this._errorMessage = null;

                Backbone.Wreqr.radio.vent.trigger('status_message', 'shown');
            }
        },

        onDomRefresh: function() {
            Backbone.Wreqr.radio.vent.trigger('timeline', 'time:shown');
        },

        showErrorMessage: function (message) {
            this._errorMessage = message;

            this.render();
        },
        
        _navigateToDate: function (event) {
            var $el = $(event.currentTarget);
            var date = $el.data('date'); 
            var model = this.getOption('bookingModel');
            
            var url = BookingUrlBuilder.getInstance().buildUrl('booking_step', {
                'date': date
            });

            model.set('start_date', date);

            if (!model.skipNavigationOnCalendar) {
                Backbone.history.navigate(url);
            }
            
            return false;
        },

        _navigateToNextAvailableDate: function (event) {
            this.triggerMethod('nextAvailableDate');
            // Backbone.Wreqr.radio.vent.trigger('timeline', 'nextAvailableDate');
        }

    });

});
